import {faLaptop, faTv} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Card, Col, Row} from 'antd';
import {observer} from 'mobx-react-lite';
import {useTranslation} from 'react-i18next';
import {Link} from 'react-router-dom';
import BlankLayout from '../shared/layouts/BlankLayout';
import {Content} from '../shared/layouts/Content';
import {OfficeRoutes} from '../office/routes';
import {ProductionTerminalRoutes} from '../operator/routes';
import styles from './ContextCard.module.scss';
import {ScopeContext} from '../../policies/scopeContext';
import {unrestricted} from '../../models/scope';

const ContextSwitch = () => {
  const {t} = useTranslation();

  return (
    <BlankLayout>
      <ScopeContext.Provider value={[unrestricted]}>
        <Content background={'transparent'}>
          <Row gutter={16}>
            <Col span={12}>
              <Link to={ProductionTerminalRoutes.all()}>
                <Card title={t('context.productionTerminal')} className={styles.contextCard}>
                  <FontAwesomeIcon icon={faTv} size="8x"/>
                </Card>
              </Link>
            </Col>
            <Col span={12}>
              <Link to={OfficeRoutes.all()}>
                <Card title={t('context.office')} className={styles.contextCard}>
                  <FontAwesomeIcon icon={faLaptop} size="8x"/>
                </Card>
              </Link>
            </Col>
          </Row>
        </Content>
      </ScopeContext.Provider>
    </BlankLayout>
  );
};

export default observer(ContextSwitch);
